// The chat window's place in every module's pages (ADR 0064 step B): a page shows the chat of a project branch (or of
// an app) without depending on the AI module above it; the web's host provides the AI module's panel at start.
import * as React from 'react';

export interface ChatPanelProps {
  slug: string;
  branch: string;
  /** The app the chat is in (its calls name it). */
  app?: string;
}

let panel: React.ComponentType<ChatPanelProps> | null = null;
/** The host provides the chat panel once, at start. */
export function provideChatPanel(p: React.ComponentType<ChatPanelProps>): void {
  panel = p;
}

/** The chat window of a project branch, or of an app. */
export function ChatPanel(p: ChatPanelProps) {
  if (!panel) throw new Error('The chat panel is not provided to this page (the host provides it at start).');
  const Panel = panel;
  return (
    <React.Suspense fallback={null}>
      <Panel {...p} />
    </React.Suspense>
  );
}
